goog.provide("shadow.js.shim.module$$tiptap$core");
goog.provide("module$shadow_js_shim_module$$tiptap$core");
shadow.js.shim.module$$tiptap$core = shadow.js.nativeProvides["@tiptap/core"] = shadow$bridge("@tiptap/core");
module$shadow_js_shim_module$$tiptap$core.default = shadow.js.shim.module$$tiptap$core;
